import React, { useState, useEffect } from 'react';
import Select from "react-select";
import { FaPlus } from "react-icons/fa6";
import Modal from 'react-bootstrap/Modal'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment/moment';

const GLAccount = ({ gLAccounts, countriesList, setGLAccounts, categoryMix, transectionData, taxList, acountCodes }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [modalData, setModalData] = useState([]);

    const [formData, setFormData] = useState({
        subgroup: null,
        accountcode: null,
        accountname: null,
        createledger: false,
        sgAccount: null,
        dateofBirth: "01-Jan-1900",
        vatNo: "",
        birthPlace: "",
        remarks: "",
        idNo: "",
        taxCode: null,
        issueDate: null,
        expiryDate: null,
        countryIssue: null,
        categoryMix: null,
    });

    const formatDate = (date) => {
        return moment(date).format("DD-MMM-YYYY");
    }

    useEffect(() => {
        if (gLAccounts) {
            setFormData(prev => ({
                ...prev,
                accountcode: gLAccounts?.accountcode || "",
                accountname: gLAccounts?.accountname || "",
                sgAccount: gLAccounts?.sgAccount || "",
                vatNo: gLAccounts?.vatNo || "",
                taxCode: gLAccounts?.taxCode,
                remarks: gLAccounts?.remarks || "",
                idNo: gLAccounts?.idNo || "",
                issueDate: gLAccounts?.issueDate || null,
                expiryDate: gLAccounts?.expiryDate || null,
                categoryMix: gLAccounts?.categoryMix || null,
                dateofBirth: gLAccounts?.dateofBirth || null,
            }));
        }
    }, [gLAccounts]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setGLAccounts(prev => ({ ...prev, [name]: value }));
    }
    const handleSelectChange = async ({ name, value }) => {
        setFormData(prev => ({ ...prev, [name]: value }));
        setGLAccounts(prev => ({ ...prev, [name]: value }));
    };
    const handlePickData = () => {
        if (selectedRow) {

            setFormData({
                subgroup: selectedRow.subgroup,
                accountcode: selectedRow.accountcode,
                accountname: selectedRow.accountname,
                createledger: false,
                sgAccount: selectedRow.sgAccount,
            });

            setGLAccounts({
                subgroup: selectedRow.subgroup,
                accountcode: selectedRow.accountcode,
                accountname: selectedRow.accountname,
                createledger: false,
                sgAccount: selectedRow.sgAccount,
            });
        }
        setSelectedRow(null);
        setIsModalOpen(false);

    }
    const handleDateChange = (input) => {
        const value = input?.target?.value || input.value;
        const name = input?.target?.name || input.name;
        const updatedValue = typeof value === 'string' ? value : formatDate(value);
        setFormData(prev => ({ ...prev, [name]: updatedValue }));
        setGLAccounts(prev => ({ ...prev, [name]: updatedValue }));

    }
    const handleCountryChange = (selectedOption) => {
        setFormData(prev => ({ ...prev, countryIssue: selectedOption }));
        setSelectedCountry(selectedOption);
    }
    return (
        <div className="cost-center-section my-3">
            <div className="border-box2 p-3" style={{ borderRadius: '8px' }}>
                <div className="form-group grid-contain ">
                    <div className="d-flex">
                        {transectionData?.type?.label === "Company" || transectionData?.type?.label === "Government" ?
                            <label className="form-label pt-1 start">Regd Date</label> :
                            <label className="form-label pt-1 start">Birth Date</label>
                        }
                        <DatePicker
                            selected={formData.dateofBirth}
                            onChange={(date) => handleDateChange({ name: 'dateofBirth', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">VAT Reg No</label>
                        <input
                            type="text"
                            className="p-2 form-control w-75"
                            name="vatNo"
                            value={formData.vatNo}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Tax Code</label>
                        <Select
                            className="p-0 w-100"
                            menuPortalTarget={document.body}
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            onChange={(selectedOption) => handleSelectChange({ name: 'taxCode', value: selectedOption })}
                            options={taxList?.map(country => ({ value: country?.value, label: country?.text }))}
                            value={formData.taxCode}
                        />
                    </div>
                    <div className="d-flex">
                        {transectionData?.type?.label === "Company" || transectionData?.type?.label === "Government" ?
                            <label className="form-label pt-1 start">Place of Incoporation</label> :
                            <label className="form-label pt-1 start">Birth Place</label>}
                        <input
                            type="text"
                            className="p-2 form-control w-75"
                            name="birthPlace"
                            value={formData.birthPlace}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Issue Date </label>
                        <DatePicker
                            selected={formData.issueDate}
                            onChange={(date) => handleDateChange({ name: 'issueDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            disabled={transectionData?.type?.label === "Company" || transectionData?.type?.label === "Government" ? true : false}
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Expiry Date </label>
                        <DatePicker
                            disabled={transectionData?.type?.label === "Company" || transectionData?.type?.label === "Government" ? true : false}
                            selected={formData.expiryDate}
                            onChange={(date) => handleDateChange({ name: 'expiryDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className="d-flex">
                        {transectionData?.type?.label === "Company" || transectionData?.type?.label === "Government" ?
                            <label className="form-label pt-1 start">Registration Number</label> :
                            <label className="form-label pt-1 start">ID No</label>}
                        <input
                            type="text"
                            className="p-2 form-control w-75"
                            name="idNo"
                            value={formData.idNo}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom18" className="form-label">Country of Issue</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={selectedCountry}
                            onChange={handleCountryChange}
                            options={countriesList?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Remarks</label>
                        <input
                            type="text"
                            className="p-2 form-control w-75"
                            name="remarks"
                            value={formData.remarks}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="d-flex">
                        <label htmlFor="validationCustom01" className="form-label pt-1 start">Category Mix</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            value={formData.categoryMix}
                            onChange={(selectedOption) => handleSelectChange({ name: 'categoryMix', value: selectedOption })}
                            options={categoryMix?.map(country => ({ value: country, label: country?.text }))}
                        />
                    </div>
                </div>
            </div>
            <div className='my-3'><h6>GL Account</h6></div>
            <div className="border-box2 p-3" style={{ borderRadius: '8px' }}>
                <div className="form-group grid-contain ">
                    {/* Contact Type */}
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Sub Group</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            onChange={(selectedOption) => handleSelectChange({ name: 'subgroup', value: selectedOption })}
                            options={acountCodes?.map(country => ({ value: country?.value, label: country?.text }))}
                            value={formData.subgroup}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Account Code</label>
                        <input
                            type="text"
                            className="p-2 form-control w-75"
                            name="accountcode"
                            value={formData.accountcode}
                            disabled={!formData.createledger}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Account Name</label>
                        <input
                            type="text"
                            className="p-2 form-control w-75"
                            name="accountname"
                            value={formData.accountname}
                            disabled={!formData.createledger}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="d-flex gap-3">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="createledger"
                            style={{ width: '20px', height: '20px' }}
                            checked={formData.createledger}
                            onChange={(e) => setFormData(prev => ({ ...prev, createledger: e.target.checked }))}
                        />
                        <label className="form-check-label" htmlFor="createledger">
                            Create Ledger
                        </label>
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">SG Code</label>
                        <input
                            type="text"
                            className="p-2 form-control w-75"
                            name="sgAccount" disabled
                            value={formData.sgAccount}
                            onChange={handleInputChange}
                        />
                    </div>
                </div>
                <div className='my-4'>

                    <div
                        className='mainbtnSecondary flex-end gap-2 w-25'
                        style={{ cursor: "pointer" }}
                    // onClick={() => setIsModalOpen(true)}
                    >
                        <FaPlus color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>
                            Pick Existing Account
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={isModalOpen} size="lg" onHide={() => setIsModalOpen(false)} backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Select Account</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <table className='table table-bordered gridshad'>
                        <thead className='dynoTable'>
                            <tr>
                                <th>Select</th>
                                <th>Account Code</th>
                                <th>Account Name</th>
                                <th>Sub Group Code</th>
                                <th>Sub Group Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            {modalData.map((row, index) => (
                                <tr key={index}>
                                    <td className="text-center">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                            style={{ width: '20px', height: '20px' }}
                                            checked={selectedRow?.accountcode === row.accountcode}
                                            onChange={() => setSelectedRow(row)}
                                        />
                                    </td>
                                    <td>{row.accountcode}</td>
                                    <td>{row.accountname}</td>
                                    <td>{row.sgAccount}</td>
                                    <td>{row.subgroup.label}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Modal.Body>
                <Modal.Footer>
                    <div>
                        <button className="mainbtnSecondary ms-auto px-3" onClick={() => setIsModalOpen(false)}>Close</button>
                    </div>
                    <div>
                        <div className='mainbtn flex-end gap-2'
                            disabled={!selectedRow}
                            onClick={handlePickData}>
                            <div className='center'>Pick</div>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default GLAccount;